import React, { useRef } from 'react'

import { useColResize } from '_hooks'
import classNames from 'classnames'

import './styles.scss'

const ResizableColumn = ({ className, children, content, minWidth = 200, maxWidth }) => {
  const containerRef = useRef()

  const {
    Divider,
    handleMouseUp,
    handleMouseMove,
    isResizing,
    panelWidth,
    isCollapsed,
  } = useColResize({
    min: minWidth,
    max: maxWidth,
    containerRef,
  })

  return (
    <div
      ref={containerRef}
      className={classNames('resizable-column', className)}
      style={{
        gridTemplateColumns: `${isCollapsed ? 60 : panelWidth}px max-content 1fr`,
        ...(isResizing ? { cursor: 'col-resize' } : {}),
      }}
      onMouseUp={handleMouseUp}
      onMouseMove={handleMouseMove}
    >
      <div className="resizable-column__column">{content}</div>
      <Divider className="resizable-column__divider relative -left-3" />
      <div className="resizable-column__panel">{children}</div>
    </div>
  )
}

export default ResizableColumn
